var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "LayoutBase",
    [
      !_vm.$wait.is("fetching preview resource")
        ? [
            _c(
              "section",
              { staticClass: "preview-section" },
              [
                _vm.completedStep(1)
                  ? [
                      _c(
                        "header",
                        { staticClass: "preview-section__header" },
                        [
                          _c("h2", { staticClass: "h1" }, [
                            _vm._v("The Project"),
                          ]),
                          _vm._v(" "),
                          _vm.canCompleteStep(1)
                            ? _c(
                                "router-link",
                                {
                                  staticClass: "btn",
                                  attrs: { to: _vm.stepLink(1) },
                                },
                                [_vm._v("Edit")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "company-info" }, [
                        _vm.resource.member.country
                          ? _c("img", {
                              directives: [
                                {
                                  name: "tippy",
                                  rawName: "v-tippy",
                                  value: _vm.resource.member.country.name,
                                  expression: "resource.member.country.name",
                                },
                              ],
                              attrs: { src: _vm.resource.member.country.flag },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("h2", [_vm._v(_vm._s(_vm.resource.projectName))]),
                      ]),
                      _vm._v(" "),
                      _vm.resource.lead
                        ? _c(
                            "div",
                            { staticClass: "profile-list" },
                            [
                              _c("p", { staticClass: "profile-list__title" }, [
                                _vm._v("Lead User"),
                              ]),
                              _vm._v(" "),
                              _c("UserCard", {
                                attrs: {
                                  user: _vm.resource.lead,
                                  borderless: true,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.filterLead(_vm.resource.team).length
                        ? _c("div", { staticClass: "profile-list" }, [
                            _c("p", { staticClass: "profile-list__title" }, [
                              _vm._v("Users also involved"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "grid" },
                              _vm._l(
                                _vm.filterLead(_vm.resource.team),
                                function (profile) {
                                  return _c(
                                    "div",
                                    { key: profile.id, staticClass: "col-3" },
                                    [
                                      _c("UserCard", {
                                        attrs: {
                                          user: profile,
                                          small: true,
                                          borderless: true,
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                }
                              ),
                              0
                            ),
                          ])
                        : _vm._e(),
                    ]
                  : _c("p", [_vm._v("Not completed")]),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "section",
              { staticClass: "preview-section" },
              [
                _c(
                  "header",
                  { staticClass: "preview-section__header" },
                  [
                    _c("h2", { staticClass: "h1" }, [_vm._v("The Company")]),
                    _vm._v(" "),
                    _vm.canCompleteStep(2)
                      ? _c(
                          "router-link",
                          {
                            staticClass: "btn",
                            attrs: { to: _vm.stepLink(2) },
                          },
                          [_vm._v("Edit")]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.completedStep(2)
                  ? [
                      _c("div", { staticClass: "company-info" }, [
                        _c("h2", [_vm._v(_vm._s(_vm.resource.projectName))]),
                        _vm._v(" "),
                        _c("ul", { staticClass: "grid post-details" }, [
                          _vm.resource.createdAt
                            ? _c("li", { staticClass: "col-3 detail" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("Posted"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "h3" },
                                  [
                                    _c("SvgIcon", {
                                      attrs: { icon: "calendar" },
                                    }),
                                    _vm._v(
                                      " " + _vm._s(_vm.resource.createdAt)
                                    ),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.resource.website
                            ? _c("li", { staticClass: "col-3 detail" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("Website"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass: "h3",
                                    attrs: {
                                      href: _vm.resource.website,
                                      target: "_blank",
                                    },
                                  },
                                  [
                                    _c("SvgIcon", { attrs: { icon: "link" } }),
                                    _vm._v(" Click here"),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.resource.location
                            ? _c("li", { staticClass: "col-6 detail" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("Location of Activities"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "h3" },
                                  [
                                    _c("SvgIcon", {
                                      attrs: { icon: "location" },
                                    }),
                                    _vm._v(" " + _vm._s(_vm.resource.location)),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e(),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "grid" }, [
                        _c("div", { staticClass: "col-12 col-grid" }, [
                          _c("div", { staticClass: "card" }, [
                            _c("div", { staticClass: "header" }, [
                              _vm._v("Company Bio"),
                            ]),
                            _vm._v(" "),
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(_vm.resource.description),
                              },
                            }),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-8 col-grid" }, [
                          _c("div", { staticClass: "card" }, [
                            _c("div", { staticClass: "header" }, [
                              _vm._v("Context"),
                            ]),
                            _vm._v(" "),
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(_vm.resource.context),
                              },
                            }),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-4 col-grid" }, [
                          _c("div", { staticClass: "card" }, [
                            _c("div", { staticClass: "header" }, [
                              _vm._v("Buyer Examples"),
                            ]),
                            _vm._v(" "),
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(_vm.resource.buyerExamples),
                              },
                            }),
                          ]),
                        ]),
                      ]),
                    ]
                  : _c("p", [_vm._v("Not completed")]),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "section",
              { staticClass: "preview-section" },
              [
                _c(
                  "header",
                  { staticClass: "preview-section__header" },
                  [
                    _c("h2", { staticClass: "h1" }, [
                      _vm._v("The Opportunity"),
                    ]),
                    _vm._v(" "),
                    _vm.canCompleteStep(3)
                      ? _c(
                          "router-link",
                          {
                            staticClass: "btn",
                            attrs: { to: _vm.stepLink(3) },
                          },
                          [_vm._v("Edit")]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.completedStep(3)
                  ? [
                      _c("ul", { staticClass: "grid post-details" }, [
                        _vm.resource.mandated
                          ? _c("li", { staticClass: "col-3 detail" }, [
                              _c("span", { staticClass: "label" }, [
                                _vm._v("Opportunity Type"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "h3" },
                                [
                                  _c("SvgIcon", { attrs: { icon: "lock" } }),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("formatMandated")(
                                          _vm.resource.mandated
                                        )
                                      )
                                  ),
                                ],
                                1
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.resource.dealType
                          ? _c("li", { staticClass: "col-3 detail" }, [
                              _c("span", { staticClass: "label" }, [
                                _vm._v("Deal Type"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "h3" },
                                [
                                  _c("SvgIcon", { attrs: { icon: "deal" } }),
                                  _vm._v(" " + _vm._s(_vm.resource.dealType)),
                                ],
                                1
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.resource.urgent !== null
                          ? _c("li", { staticClass: "col-3 detail" }, [
                              _c("span", { staticClass: "label" }, [
                                _vm._v("Priority"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "h3" },
                                [
                                  _c("SvgIcon", {
                                    attrs: { icon: "priority" },
                                  }),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("formatUrgency")(
                                          _vm.resource.urgent
                                        )
                                      )
                                  ),
                                ],
                                1
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.resource.respond_by
                          ? _c("li", { staticClass: "col-3 detail" }, [
                              _c("span", { staticClass: "label" }, [
                                _vm._v("Response Details"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "h3" },
                                [
                                  _c("SvgIcon", {
                                    attrs: { icon: "calendar" },
                                  }),
                                  _vm._v(" " + _vm._s(_vm.resource.respond_by)),
                                ],
                                1
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.resource.sectors
                          ? _c(
                              "li",
                              { staticClass: "col-12 detail" },
                              [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("Sectors"),
                                ]),
                                _vm._v(" "),
                                _vm._l(_vm.resource.sectors, function (sector) {
                                  return _c("span", { staticClass: "sector" }, [
                                    _vm._v(_vm._s(sector.name)),
                                  ])
                                }),
                              ],
                              2
                            )
                          : _vm._e(),
                      ]),
                    ]
                  : _c("p", [_vm._v("Not completed")]),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "section",
              { staticClass: "preview-section" },
              [
                _c(
                  "header",
                  { staticClass: "preview-section__header" },
                  [
                    _c("h2", { staticClass: "h1" }, [_vm._v("Values")]),
                    _vm._v(" "),
                    _vm.canCompleteStep(4)
                      ? _c(
                          "router-link",
                          {
                            staticClass: "btn",
                            attrs: { to: _vm.stepLink(4) },
                          },
                          [_vm._v("Edit")]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.completedStep(4)
                  ? [
                      _c("ul", { staticClass: "grid post-details" }, [
                        _vm.resource.currency
                          ? _c("li", { staticClass: "col-2 detail" }, [
                              _c("span", { staticClass: "label" }, [
                                _vm._v("Currency"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "strong",
                                [
                                  _c("SvgIcon", { attrs: { icon: "money" } }),
                                  _vm._v(" " + _vm._s(_vm.resource.currency)),
                                ],
                                1
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.resource.companyRevenue
                          ? _c("li", { staticClass: "col-2 detail" }, [
                              _c("span", { staticClass: "label" }, [
                                _vm._v("Revenue"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "strong",
                                [
                                  _c("SvgIcon", { attrs: { icon: "value" } }),
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.resource.companyRevenue) +
                                      "m"
                                  ),
                                ],
                                1
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.resource.projectedValueFrom &&
                        _vm.resource.projectedValueTo
                          ? _c("li", { staticClass: "col-3 detail" }, [
                              _c("span", { staticClass: "label" }, [
                                _vm._v("Projected transaction value"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "strong",
                                [
                                  _c("SvgIcon", { attrs: { icon: "value" } }),
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.resource.projectedValueFrom) +
                                      "m-" +
                                      _vm._s(_vm.resource.projectedValueTo) +
                                      "m"
                                  ),
                                ],
                                1
                              ),
                            ])
                          : _vm._e(),
                      ]),
                    ]
                  : _c("p", [_vm._v("Not completed")]),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "section",
              { staticClass: "preview-section" },
              [
                _c(
                  "header",
                  { staticClass: "preview-section__header" },
                  [
                    _c("h2", { staticClass: "h1" }, [
                      _vm._v("Supporting Documents"),
                    ]),
                    _vm._v(" "),
                    _vm.canCompleteStep(5)
                      ? _c(
                          "router-link",
                          {
                            staticClass: "btn",
                            attrs: { to: _vm.stepLink(5) },
                          },
                          [_vm._v("Edit")]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.completedStep(5)
                  ? [
                      _vm.resource.documents
                        ? _c("div", { staticClass: "card" }, [
                            _c("span", { staticClass: "header" }, [
                              _vm._v("Attachments"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "ul",
                              { staticClass: "unstyled" },
                              _vm._l(_vm.resource.documents, function (doc) {
                                return _c(
                                  "li",
                                  [
                                    _c("AttachmentDownload", {
                                      attrs: { attachment: doc },
                                    }),
                                  ],
                                  1
                                )
                              }),
                              0
                            ),
                          ])
                        : _vm._e(),
                    ]
                  : _c("p", [_vm._v("Not completed")]),
              ],
              2
            ),
            _vm._v(" "),
            _c("div", { staticClass: "form" }, [
              _c(
                "div",
                { staticClass: "form__group form__group--submit-fixed" },
                [
                  _vm.resource.can.delete
                    ? _c(
                        "button",
                        {
                          directives: [
                            {
                              name: "wait",
                              rawName: "v-wait:disabled",
                              value: [
                                "saving preview resource",
                                "deleting preview resource",
                              ],
                              expression:
                                "['saving preview resource', 'deleting preview resource']",
                              arg: "disabled",
                            },
                          ],
                          staticClass: "btn btn--danger",
                          on: {
                            click: function ($event) {
                              return _vm.showDeleteModal()
                            },
                          },
                        },
                        [_vm._v("\n\t\t\t\t\t\tDelete Opportunity\n\t\t\t\t\t")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "router-link",
                    {
                      directives: [
                        {
                          name: "wait",
                          rawName: "v-wait:disabled",
                          value: "saving preview resource",
                          expression: "'saving preview resource'",
                          arg: "disabled",
                        },
                      ],
                      staticClass: "btn",
                      attrs: {
                        to: { name: "opportunities", params: { tab: "mine" } },
                      },
                    },
                    [_vm._v("\n\t\t\t\t\t\tSave and Leave\n\t\t\t\t\t")]
                  ),
                  _vm._v(" "),
                  _vm.resource.can.submit
                    ? _c(
                        "router-link",
                        {
                          directives: [
                            {
                              name: "wait",
                              rawName: "v-wait:disabled",
                              value: "saving preview resource",
                              expression: "'saving preview resource'",
                              arg: "disabled",
                            },
                          ],
                          staticClass: "btn btn--primary btn--no-stretch",
                          attrs: {
                            to: {
                              name: "share-opportunity",
                              params: { opportunity_id: this.id },
                            },
                          },
                        },
                        [_vm._v("\n\t\t\t\t\t\tSubmit Opportunity\n\t\t\t\t\t")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }